import axios from "axios";

import ApiException from "./ApiException";
import config from "@/app.config.json";
import { ValidacaoResult } from "@/services/Interfaces/IValidacaoResult";

const urlBase = `${config.urlApi}/Contratos`;  //import.meta.env.VITE_URL_API;

const urls = {
  obter: `${urlBase}`,
  obterPorId: `${urlBase}`,
  adicionar: `${urlBase}`,
  alterar: `${urlBase}`,
  excluir: `${urlBase}`,

  obterContratosPorCliente: `${urlBase}/ObterContratosPorCliente`,
  obterStatus: `${urlBase}/ObterStatus`,
  sincronizarTexto: `${urlBase}/SincronizarTexto`,
  extenderContrato: `${urlBase}/ExtenderContrato`,
}


function getToken(): string {

  const x = localStorage.getItem('user');

  if (x != null) {
    const user = JSON.parse(x);

    if (user && user.accessToken) {
      return `Bearer  ${user.accessToken}`;
    } else {
      return "";
    }
  }
  else
    return "";
}

export const obterPorId = (id: number): Promise<Contrato> => {
  return new Promise((resolve, reject) => {

    const params = {
      id: id
    }

    console.log("obterPorId", id);
    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(`${urls.obterPorId}/${id}`, { params })
      .then((response) => {
        return resolve(response.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter por id")));
  });
};

export const obter = (params?: Filtros | null | any): Promise<Contrato[]> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(urls.obter, { params })
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export const obterContratosPorCliente = (clienteId: number): Promise<Contrato[]> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(`${urls.obterContratosPorCliente}/${clienteId}`  )
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};

export async function salvar(model: Contrato): Promise<Contrato> {
  try {
    // Configurar token de autorização
    axios.defaults.headers.common.Authorization = getToken();

    if (model.contratoId && model.contratoId > 0) {
      return (await axios.put(`${urls.alterar}/${model.contratoId}`, model)).data
    } else {
      return (await axios.post(urls.adicionar, model)).data
    }
  } catch (error: any) {
    throw new ApiException(error || "Falha ao salvar ");
  }
}

export async function excluir(id: number): Promise<void> {
  axios.defaults.headers.common.Authorization = getToken();

  try {
    await axios.delete(`${urls.excluir}/${id}`)
  } catch (error: any) {
    throw new ApiException(error || "Falha ao excluir");
  }
}

export const obterStatus = (): Promise<ContratoStatus[]> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(urls.obterStatus)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao obter ")));
  });
};


export const SalvarAssinaturaBase64 = (docto: UploadAssinaturaDto): Promise<string> => {
  return new Promise((resolve, reject) => {

    const formData = new FormData();
    formData.append('contratoId', docto.contratoId.toString());
    formData.append('arquivoBase64', docto.arquivoBase64);

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(`${urlBase}/SalvarAssinaturaBase64?id=${docto.contratoId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => {
        return resolve(response.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao fazer upload da assinatura")));
  });
};

export const sincronizarTexto = (contratoIds: number[]): Promise<ContratoSincronizarResultadoDTO[]> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(urls.sincronizarTexto, { contratoIds })
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao sincronizar texto dos contratos")));
  });
};

export interface ContratoSincronizarResultadoDTO {
  contratoId: number;
  sucesso: boolean;
  mensagem: string;
}

export const extenderContrato = (params: ExtenderContratoDTO): Promise<void> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(urls.extenderContrato, params)
      .then(() => {
        return resolve();
      })
      .catch(error => reject(new ApiException(error || "Falha ao extender contrato")));
  });
};

export interface ExtenderContratoDTO {
  contratoId: number;
  dataInicial: string | null;
  mesesExtender: number;
}

export const cancelarContrato = (contratoId: number, motivo: string | null): Promise<CancelarContratoResultado> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(`${urlBase}/${contratoId}/Cancelar`, { motivo })
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao cancelar contrato")));
  });
};

export interface CancelarContratoResultado {
  parcelasCanceladas: number;
  boletosCancelados: number;
  parcelasMantidas: number;
}

export const simularParcelas =(contratoId: number, dataInicial: string, dataFinal: string): Promise<ParcelaSimulada[]> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(`${urlBase}/${contratoId}/SimularParcelas`, { params: { dataInicial, dataFinal } })
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao simular parcelas")));
  });
};

export const gerarParcelas = (contratoId: number, parcelas: ParcelaSimulada[]): Promise<{ geradas: number }> => {
  return new Promise((resolve, reject) => {

    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(`${urlBase}/${contratoId}/GerarParcelas`, parcelas)
      .then((r) => {
        return resolve(r.data);
      })
      .catch(error => reject(new ApiException(error || "Falha ao gerar parcelas")));
  });
};

export interface ParcelaSimulada {
  parcela: number;
  dataVencimento: string;
  valor: number;
}

export interface Filtros {
  clienteId?: number ;
  contratoId?: number ;
  nome?: string ;
  vendedorId?: number ;
  planoId?: number ;
  supervisorId?: number ;
  empresaId?: number ;
  statusId?: number ;
  paginaAtual?: number ;
  tamanhoPagina?: number ;
}

export interface Contrato {
  contratoId: number;
  planoId: number;
  plano: plano;
  vendedorId: number | null;
 
  investidorId: number | null;
  investidor: Usuario | null;
  supervisorId: number | null;
  supervisor: Usuario | null;
  clienteId: number | null;
  empresaId: number | null;
  preContrato: boolean | null;
  dataPriParcela: Date | null;
  statusId: number;
  
  dataInicio: string | null;
  dataFim: string | null;
  comSeguro: boolean;
  dataCancelamento: string | null;
  motivoCancelamento: string | null;
  assinatura: string | null;
  dataAssinatura: string | null;
  arquivo: string | null;
  texto: string | null;
  observacoes: string | null;

  dataCadastro: string | null;
  usuCadastroId: number | null;
  dataAlteracao: string | null;
  usuAlteracaoId: number | null;
  dataExclusao: string | null;
  usuExclusaoId: number | null;
  modelState: ValidacaoResult;

  status: ContratoStatus;
  vendedor: Usuario | null;
  cliente: Cliente | null;
  empresa: Empresa | null;
}

export interface Cliente {
  clienteId: number;
  nome: string;
  cpf: string;
}

export interface Empresa {
  empresaId : number;
  nome: string;
  cnpj: string;
}

export interface ContratoStatus {
  statusId: number;
  descricao: string;
}

export interface plano {
  planoId: number;
  nome: string;
  idadeMinima: number | null;
  idadeMaxima: number | null;
  maximoPessoas: number | null;
  valor: number;
  permiteSeguro: boolean;
  valorComSeguro: number;
}

export interface Usuario {
  usuarioId: number;
  nomeCompleto: string;
}

export interface UploadAssinaturaDto {
  contratoId: number;
  arquivoBase64: string;
}